/**
 * 移动端弃单列表页
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  List,
  PullToRefresh,
  Empty,
  Skeleton,
  InfiniteScroll,
  Dialog,
  Tag,
  SearchBar,
} from 'antd-mobile';
import { adminAbandonedOrderApi } from '../../api/index';
import Toast from 'antd-mobile/es/components/toast';

export default function MobileAbandonedOrderListPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');

  useEffect(() => {
    fetchOrders(1);
  }, [searchKeyword]);

  const fetchOrders = async (pageNum, append = false) => {
    try {
      const params = {
        page: pageNum,
        pageSize: 10,
        keyword: searchKeyword || undefined,
      };
      const data = await adminAbandonedOrderApi.list(params);
      const newOrders = data?.items || data?.list || data || [];
      if (append) {
        setOrders((prev) => [...prev, ...newOrders]);
      } else {
        setOrders(newOrders);
      }
      setHasMore(newOrders.length >= 10);
      setPage(pageNum);
    } catch (err) {
      Toast.show('获取弃单列表失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setSearchKeyword(keyword);
  };

  const loadMore = async () => {
    if (!hasMore) return;
    await fetchOrders(page + 1, true);
  };

  const refreshData = async () => {
    await fetchOrders(1, false);
  };

  const handleRecover = (id) => {
    Dialog.confirm({
      content: '确定要恢复此订单吗？',
      onConfirm: async () => {
        try {
          await adminAbandonedOrderApi.recover(id);
          Toast.show('恢复成功');
          fetchOrders(1);
        } catch (err) {
          Toast.show(err?.response?.data?.message || '恢复失败');
        }
      },
    });
  };

  const handleDelete = (id) => {
    Dialog.confirm({
      content: '确定要删除此弃单吗？',
      onConfirm: async () => {
        try {
          await adminAbandonedOrderApi.delete(id);
          Toast.show('删除成功');
          fetchOrders(1);
        } catch (err) {
          Toast.show(err?.response?.data?.message || '删除失败');
        }
      },
    });
  };

  if (loading && orders.length === 0) {
    return (
      <div style={{ padding: 16 }}>
        <Skeleton.Title rows={3} />
        <Skeleton.Title rows={5} style={{ marginTop: 16 }} />
        <Skeleton.Title rows={5} style={{ marginTop: 16 }} />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: 16 }}>
      {/* 搜索栏 */}
      <div style={{ background: '#fff', padding: '6px 12px', marginBottom: 12, borderRadius: 8 }}>
        <SearchBar
          value={keyword}
          onChange={setKeyword}
          onSearch={handleSearch}
          placeholder="搜索订单号或邮箱"
          style={{ '--background': '#f5f5f5' }}
        />
      </div>

      <div style={{ marginBottom: 12 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600 }}>弃单管理</h2>
        <p style={{ fontSize: 13, color: '#999' }}>用户未支付成功的订单记录</p>
      </div>

      <PullToRefresh onRefresh={refreshData}>
        {orders.length > 0 ? (
          <List>
            {orders.map((order) => (
              <List.Item
                key={order.id}
                style={{
                  background: '#fff',
                  marginBottom: 12,
                  padding: '12px 16px',
                }}
                description={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                    <Tag size="small" color="warning">弃单</Tag>
                    <span style={{ fontSize: 13, color: '#999' }}>
                      {order.abandonedAt?.slice(0, 10)}
                    </span>
                  </div>
                }
                extra={
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 16, fontWeight: 600, color: '#f5222d' }}>
                      ${order.total?.toFixed(2) || '0.00'}
                    </div>
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
                      <span
                        style={{ fontSize: 13, color: '#1677ff', cursor: 'pointer' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRecover(order.id);
                        }}
                      >
                        恢复
                      </span>
                      <span
                        style={{ fontSize: 13, color: '#ff4d4f', cursor: 'pointer' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(order.id);
                        }}
                      >
                        删除
                      </span>
                    </div>
                  </div>
                }
              >
                <div style={{ fontSize: 14, fontWeight: 500 }}>{order.orderNo}</div>
                <div style={{ fontSize: 13, color: '#999' }}>{order.email}</div>
              </List.Item>
            ))}
          </List>
        ) : (
          <div style={{ padding: '80px 0' }}>
            <Empty description="暂无弃单" />
          </div>
        )}
      </PullToRefresh>

      {/* 无限滚动加载 */}
      {orders.length > 0 && hasMore && (
        <InfiniteScroll loadMore={loadMore} style={{ paddingBottom: 60 }} />
      )}
    </div>
  );
}
